export default (payload) => ({
  type: 'DELETE_CUSTOMER_STATE',
  payload,
});
